/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNotPlayable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m14.747 16.161 7.546 7.546 1.414-1.414-22-22L.293 1.707 5 6.414v15.491zm-1.46-1.46L7 18.405v-9.99zm8.683-2.796-4.54 2.676-1.461-1.46 2.061-1.216-7.977-4.7L5 2.15v-.246z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNotPlayable as NotPlayable };
